exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.alert[data-v-4b5f9e41]{\n    margin-bottom:0;\n}\n", ""]);

// exports
